import { Tooltip } from 'shared/components/charts/BarChart/components/Chart/components/Tooltip';
import { isIntractable } from 'shared/components/charts/BarChart/components/Chart/utils';
import { useChartContext } from 'shared/components/charts/BarChart/hooks';

import { BarEmpty } from './components/BarEmpty';
import { BarFilled } from './components/BarFilled';

import type { FC } from 'react';
import type { DataPoint as BarProps } from 'shared/components/charts/BarChart/types';

export const Bar: FC<BarProps> = ({ id, x, yLabel, y }) => {
  const { TooltipContent, onInteract, gradeType } = useChartContext();
  const intractable = isIntractable(yLabel);

  return (
    <Tooltip
      title={<TooltipContent x={x} yLabel={yLabel} gradeType={gradeType} />}
    >
      <g
        onClick={() => intractable && onInteract(id)}
        cursor={intractable ? 'pointer' : 'initial'}
      >
        <BarEmpty x={x} y={0} />
        <BarFilled x={x} y={y} />
      </g>
    </Tooltip>
  );
};
